/*  ========================================================================
    # Tailwind CSS - Config
    ========================================================================  */

module.exports = {
  content: [
    './theme/functions/**/*.php',
    './theme/classes/**/*.php',
    './src/react/**/*.{js,jsx,ts,tsx}'
  ],
  prefix: 'tw-',
  corePlugins: {
    preflight: false,
    container: false
  },
  plugins: [],
  theme: {
    screens: {
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1500px'
    }
  }
};
